import {
  createQuery,
  createSuspenseQuery
} from "../../utils/queryFactories.js";
import { api } from "../../utils/fetch.js";
import { z } from "zod";

const ViewEventsSchema = z.array(
  z.object({
    resource_id: z.number(),
    resource_label: z.string().nullable(),
    task_id: z.number(),
    task_name: z.string(),
    task_color: z.string().nullable(),
    task_style: z.string().nullable(),
    start_time: z.string(),
    end_time: z.string()
  })
);

const ViewEventsRequestSchema = z.object({
  id: z.string(),
  start_datetime: z.string(),
  end_datetime: z.string()
});

type ViewEventsRequest = z.infer<typeof ViewEventsRequestSchema>;

type ViewEventsResponse = z.infer<typeof ViewEventsSchema>;

export const useViewEvents = createQuery<
  ViewEventsResponse,
  ViewEventsRequest,
  Error
>({
  queryKey: ["ViewEvents"],
  staleTime: 1000 * 60,
  fetcher: async (variables) => {
    const result = await api<ViewEventsRequest, ViewEventsResponse>({
      method: "GET",
      url: `/views/:id/events`,
      requestSchema: ViewEventsRequestSchema,
      responseSchema: ViewEventsSchema,
      body: variables
    });
    return result;
  }
});

export const useViewEventsWithSuspense = createSuspenseQuery<
  ViewEventsResponse,
  ViewEventsRequest,
  Error
>({
  queryKey: ["ViewEventsWithSuspense"],
  staleTime: 1000 * 60,
  fetcher: async (variables) => {
    const result = await api<ViewEventsRequest, ViewEventsResponse>({
      method: "GET",
      url: `/views/:id/events`,
      requestSchema: ViewEventsRequestSchema,
      responseSchema: ViewEventsSchema,
      body: variables
    });
    return result;
  }
});
